import React from "react"
export default function LegalDetail({ policyData }) {
    return (
        // <div className="blogContant">
        <div className="legalPara"  dangerouslySetInnerHTML={{ __html: policyData?.body }}></div>
        // </div>
    )

}